import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-leaves-details',
  templateUrl: './my-leaves-details.component.html',
  styleUrls: ['./my-leaves-details.component.css'],
})
export class MyLeavesDetailsComponent implements OnInit {
  showData = true;
  financialYearList;
  leaveForm;
  showReports = false;
  reports = [];
  fyName;
  uType;
  uFName;
  uLName;
  uMName;
  userId;
  leaveDetailsList = [];

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private masterDataService: MasterDataService,
    private reportService: DiaryReportService,
    private router: Router,
    private commonMessageService:CommonMessageService
  ) {}

  ngOnInit(): void {
    this.loadFinancialYear();
    this.initDiaryForm();
    this.uFName = localStorage.getItem('userFname');
    this.uMName=localStorage.getItem('userMname');
    this.uLName = localStorage.getItem('userLname');

    this.userId = localStorage.getItem('id');
  }

  initDiaryForm() {
    this.leaveForm = this.fb.group({
      fy: ['', [Validators.required]],
    });
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      console.log('years :', res);
      this.financialYearList = res;
    });
  }

  onViewReport() {
    if(this.leaveForm.controls['fy'].value==""||
    this.leaveForm.controls['fy'].value==null||
    this.leaveForm.controls['fy'].value==""){
      this.commonMessageService.swalAlertWithoutIcon('','Please select Financial Year');
      return;
    }
    this.uType = localStorage.getItem('userType');
    var fYId = this.leaveForm.value.fy.id;
    this.fyName = this.leaveForm.value.fy.name;
    var userId = localStorage.getItem('id');
    this.showReports = true;
    this.reportService.getMyLeavesReport(userId, fYId).subscribe(
      (resp: any) => {
        this.reports = resp;
         console.log('res',this.reports);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  goBack() {
    this.showData = true;
  }

  getPerticularUserDetails(month, year) {
    this.showData = false;
    month = moment().month(month).format('M');

    this.reportService
      .getIndividualLeaveReport(this.userId, year, month)
      .subscribe((res: any) => {
        this.leaveDetailsList = res;
      });
  }
}
